import { NewsletterBanner } from './NewsletterBanner';

export type { TypeNewsletterBannerProps } from './types';
export default NewsletterBanner;
